module.exports = __webpack_public_path__ + "img/exporo-logo-dark.f88e39a9.svg";